import { OpenPresetModalDefinition } from "@modules/+new/shared/universal-modal/entities/modal-definition.interface";
import { PendingData } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/entities/pending-data";
import { PendingPresetComponent } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/pending-preset.component";
import { ModalSizes } from "@modules/+new/shared/universal-modal/entities/modal-size.enum";
import { PresetsComponentsEnum } from "@modules/+new/shared/universal-modal/entities/presets-components.enum";

export const PendingPresetDefinition: OpenPresetModalDefinition<PendingData> = {
	component: PendingPresetComponent,
	options: {
		wrap: false,
		size: ModalSizes.lg,
		showCancel: false,
		showPrevious: false,
		cancelKey: "close",
		isPreset: PresetsComponentsEnum.pending
	}
};
